import { createSelector } from 'reselect';
import HandlerMailRegistrationDeviceDeliveryDetailsColumns from '../../containers/HandlerMailRegistrationDeviceDeliveryDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS.isLoading;

export const getData =
  ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, HandlerMailRegistrationDeviceDeliveryDetailsColumns);
